export default {
	Range: require("./range").default,
	Color: require("./color").default,
	Toggle: require("./toggle").default,
	Text: require("./text").default,
	Number: require("./number").default,
	Select: require("./select").default,
	File: require("./file").default,
	Button: require("./button").default
};
